// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Approval = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeWidth="2" d="M5 10v12.7431" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 23.0211V10.278h4.7787S11 1 16 1c4.7563 0-2.2569 7.6852-2.2569 7.6852h6.3716c4.7786 0 3.1857 14.3359-1.5929 14.3359H1z" /></React.Fragment>, },
  'default'
);
